// Opens the Strata Playbook in a new tab through the backend sign-in handoff
// (POST /playbook/access-ticket), optionally landing on `path` (e.g. "/guides/budgeting").
// The tab is opened synchronously inside the click so it isn't blocked as a popup;
// `opener` is nulled before navigating so the Playbook can't reach this window.
import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { requestPlaybookUrl } from '@/api/playbook';

export function useOpenPlaybook() {
  const [loading, setLoading] = useState(false);
  const open = useCallback(async (path) => {
    if (loading) return;
    setLoading(true);
    const playbookWindow = window.open('', '_blank');
    if (!playbookWindow) {
      setLoading(false);
      toast.error('We couldn\u2019t open the Strata Playbook. Please allow pop-ups, or contact support.');
      return;
    }
    try { playbookWindow.opener = null; } catch { /* noopener */ }
    try {
      const url = await requestPlaybookUrl(path);
      if (!url) throw new Error('Playbook access response did not include a URL');
      playbookWindow.location.replace(url);
    } catch {
      try { playbookWindow.close(); } catch { /* noop */ }
      toast.error('We couldn\u2019t open the Strata Playbook. Please try again or contact support.');
    } finally {
      setLoading(false);
    }
  }, [loading]);
  return { open, loading };
}
